import { useCallback, useEffect, useState } from 'react';
import { useRouterActions } from '../router';
export var useRouteConfirm = function (_a) {
    var showConfirm = _a.showConfirm, render = _a.render;
    var _b = useRouterActions(), block = _b.block, goTo = _b.goTo, replace = _b.replace, resolveRoute = _b.resolveRoute, unblock = _b.unblock;
    var _c = useState(false), isActive = _c[0], setActive = _c[1];
    var _d = useState(null), action = _d[0], setAction = _d[1];
    var _e = useState(null), nextPathname = _e[0], setNextPathname = _e[1];
    var handleCancel = useCallback(function () {
        setActive(false);
        setNextPathname(null);
    }, []);
    var handleConfirm = useCallback(function () {
        unblock();
        var _a = resolveRoute(nextPathname || ''), name = _a.name, params = _a.params, query = _a.query;
        if (action === 'REPLACE') {
            replace(name, params, query);
            return;
        }
        goTo(name, params, query);
    }, [action, nextPathname]);
    useEffect(function () {
        block(function (_a, action) {
            var pathname = _a.pathname, hash = _a.hash;
            if (showConfirm) {
                setActive(true);
                setAction(action);
                setNextPathname(hash || pathname);
                return false;
            }
            return;
        });
        return function () {
            unblock();
        };
    }, [showConfirm]);
    return render({ isActive: isActive, cancel: handleCancel, confirm: handleConfirm });
};
//# sourceMappingURL=useRouteConfirm.js.map